import "./generator.css";
import { useState } from "react";

function Header() {
  return (
    <>
      <nav>
        <h2 
          onClick={(e) => window.location.reload(false)}
          style={{cursor:"pointer"}}
        >📝 Article Generator</h2>
        <svg 
          width="40" 
          height="40" 
          viewBox="0 0 64 64" 
          xmlns="http://www.w3.org/2000/svg"

          style={{cursor:"pointer"}}
        >
            <path fill="#f5eb35" d="M27.576 39.727c1.576-2.194 2.719-4.756.662-7.07c-.882-.994-2.471-1.479-3.65-1.976a11.918 11.918 0 0 1-2.212-1.25c-1.844-4.974-2.795-10.271-1.891-15.474c.907-5.219 3.135-9.535 5.759-13.672C11.81 3.43.994 16.267.994 31.643c0 17.736 14.377 32.11 32.11 32.11c5.898 0 11.407-1.617 16.16-4.393c-8.693-4.891-16.369-11.246-21.689-19.634"/>
            <g fill="#e0cf35">
                <path d="M8.112 40.18a2.552 2.552 0 0 1-5.106 0a2.553 2.553 0 1 1 5.106 0M36.15 57.34a3.494 3.494 0 0 1-3.498 3.494a3.495 3.495 0 0 1 0-6.991a3.495 3.495 0 0 1 3.498 3.497"/>
                <circle cx="15.14" cy="12.415" r="2.075"/>
            </g>
            <path fill="#bfad2b" d="M30.06 44.561c-4.551 2.111-8.549 2.815-13.37 1.2c.043-.414.106-.828.188-1.239c.251-1.255-1.652-1.907-1.905-.637c-.354 1.755-.58 3.562-.032 5.303c.385 1.223 2.359.827 1.968-.415a5.9 5.9 0 0 1-.197-.909c5.04 1.514 9.431.73 14.247-1.503c1.179-.549.275-2.346-.899-1.8"/>
            <path fill="#fff" d="M16.952 22.504c-.384-.61-2.037 1.352-2.414 1.855c-1.295 1.705-2.338 2.96-3.849 4.459c-.027.024-.033.055-.059.083c-.067 0-.134-.008-.201-.004c-1.385.126-1.014 2.255.37 2.133c1.218-.11 2.381.472 3.507.869c1.105.389 2.21.579 3.378.467c.47-.045 1.774.106 1.814-.348c.189-2.462-1.214-7.416-2.546-9.514"/>
            <path fill="#24363f" d="M19.499 31.29c.25-1.208.191-2.539-.158-3.894c-.315-1.221-.818-2.375-1.619-3.358c-.67 1.21-1.1 2.574-.834 3.958c.299 1.562 1.371 2.521 2.611 3.294"/>
            <path fill="#bfad2b" d="M20.814 32.02c-.539-.029-8.178-.487-10.286-1.673c.88-1.253 2.652-4.063 4.161-5.32c.988-.823 3.32-2.273 4.675-3.2c.938-1.021-.261-2.514-1.373-1.669c-3.901 2.96-8.25 5.52-9.987 10.06c-.984 2.569 8.101 2.845 11.675 3.373c1.281.188 2.202-1.143 1.135-1.569"/>
            <path fill="#e0cf35" d="M23.537 37.05c.574-.506 1.187-.743 1.957-.723c.389.012.808.397 1.073.644c.029.03.652.7.341.692c-.715-.021-1.276.185-1.814.66c-.343.301-1.777-1.081-1.557-1.273"/>
        </svg>
      </nav>
    </>
  );
}

export default Header;
